import { useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Typography,
  Box
} from '@mui/material';
import { useLanguage } from '../../../../utils/i18n';

const fmtDateID = (iso) => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (isNaN(d)) return '-';
  return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric' });
};

const fmtRp = (v) => {
  if (v == null || v === '') return '-';
  const n = Number(v);
  if (isNaN(n)) return '-';
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', maximumFractionDigits: 0 }).format(n);
};

export default function DetailServiceTypeDialog({ open, onClose, data = {} }) {
  const { t } = useLanguage();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const services = Array.isArray(data?.vm_service_type) ? data.vm_service_type : [];

  const totalPrice = useMemo(() => {
    return services.reduce((acc, s) => acc + (Number(s.price) || 0), 0);
  }, [services]);

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{t('workOrder.completeWo', 'Complete WO')}</DialogTitle>

      <DialogContent dividers>
        {/* Optional header info */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Typography variant="subtitle2">
            {t('workOrder.woNumber', 'WO Number')}: {data?.vm_number ?? '-'}
          </Typography>
          <Typography variant="subtitle2">
            {t('workOrder.vehicle', 'Vehicle')}: {data?.license_plate ?? '-'}
          </Typography>
        </Box>

        {services.length === 0 ? (
          <Typography>{t('workOrder.noServiceTypeFound', 'No service type found')}</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600 }}>{t('workOrder.task', 'Task')}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t('workOrder.scheduleBy', 'Schedule By')}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t('workOrder.nextServiceOdo', 'Next Service Odo')}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t('workOrder.nextServiceDate', 'Next Service Date')}</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>{t('workOrder.remark', 'Remark')}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 600 }}>
                  {t('workOrder.serviceCost', 'Service Cost')}
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {services.map((s) => (
                <TableRow key={s.id}>
                  <TableCell>{s.service_type_name ?? s.join?.service_type_name ?? '-'}</TableCell>
                  <TableCell>{s.schedule_by ?? '-'}</TableCell>
                  <TableCell>{s.next_service_odo ?? '-'}</TableCell>
                  <TableCell>{fmtDateID(s.next_service_date)}</TableCell>
                  <TableCell>{s.remarks ?? '-'}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 600 }}>
                    {fmtRp(s.price)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>

            <TableFooter>
              <TableRow>
                <TableCell colSpan={4} />
                <TableCell sx={{ fontWeight: 600, textAlign: 'right' }}>{t('workOrder.totalPrice', 'Total Price')}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>
                  {fmtRp(totalPrice)}
                </TableCell>
              </TableRow>
            </TableFooter>
          </Table>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{t('general.close', 'Close')}</Button>
      </DialogActions>
    </Dialog>
  );
}
